import { Navigate, useSearchParams } from 'react-router-dom';

/** `/financeiro/extratos` (e variantes) → Contas bancárias, preservando a conta pedida (`?conta=ID` abre o extrato dela). */
export function RedirecionarExtratos(): JSX.Element {
  const [sp] = useSearchParams();
  const conta = Number(sp.get('conta'));
  const qs = Number.isInteger(conta) && conta > 0 ? `?conta=${conta}` : '';
  return <Navigate replace to={`/financeiro/contas${qs}`} />;
}
